const videoPlayer = function (elem){
	this.ui = {};
	this.ui.videoPlayer = elem;

	this.bindUI = function() {

		this.ui.player       = this.ui.videoPlayer;
		this.ui.controls     = this.ui.videoPlayer.querySelector('.js-videoPlayer__controls');
		this.ui.fullscreen   = this.ui.videoPlayer.querySelector('.js-videoPlayer__fullscreen-btn');
		this.ui.playButton   = this.ui.videoPlayer.querySelector('.js-play');
		// this.ui.speedSelect  = this.ui.videoPlayer.querySelector('select');
		this.ui.timeCounter  = this.ui.videoPlayer.querySelector('.js-time');
		this.ui.timeBar      = this.ui.videoPlayer.querySelector('.js-time-bar');
		this.ui.video        = this.ui.videoPlayer.querySelector('video');
		this.ui.volumeSlider = this.ui.videoPlayer.querySelector('.js-volume-bar');
		this.ui.toggleMuteBtn = this.ui.videoPlayer.querySelector('.js-toggle-mute');
		this.ui.timeProgress = this.ui.videoPlayer.querySelector('.js-time-progress');

		this.isMouseDown     = false,
		this.timeTotal       = 0,
		this.uiTimeout       = '',
		this.videoStatus     = 'paused';
	};

	this.bindEvents = function() {
		// this.ui.videoPlayer.on('click', this.toggleZoom.bind(this));

		this.ui.controls.addEventListener('mousemove', this.showUI.bind(this));
		this.ui.controls.addEventListener('mouseout', this.hideUI.bind(this));

		this.ui.controls.childNodes.forEach(control => control.addEventListener('mousedown', this.onMouseDown.bind(this)));
		this.ui.controls.childNodes.forEach(control => control.addEventListener('mouseup', this.onMouseUp.bind(this)));
		this.ui.controls.childNodes.forEach(control => control.addEventListener('touchstart', this.onMouseDown.bind(this)));
		this.ui.controls.childNodes.forEach(control => control.addEventListener('touchend', this.onMouseUp.bind(this)));


		this.ui.fullscreen.addEventListener('click', this.toggleFullScreen.bind(this));
		this.ui.playButton.addEventListener('click', this.playVideo.bind(this));
		this.ui.toggleMuteBtn.addEventListener('click', this.toggleMute.bind(this));

		this.ui.player.addEventListener('fullscreenchange', this.setVideoSize.bind(this));
		this.ui.player.addEventListener('msfullscreenchange', this.setVideoSize.bind(this));

		// this.ui.speedSelect.addEventListener('click', () => this.ui.video.playbackRate = this.ui.speedSelect.value);
		this.ui.timeBar.addEventListener('change', this.updatetimeBar.bind(this));
		this.ui.timeBar.addEventListener('mousemove', this.updatetimeBar.bind(this));

		this.ui.video.addEventListener('mouseup', this.playVideo.bind(this));
		this.ui.video.addEventListener('touchend', this.playVideo.bind(this).bind(this));
		this.ui.video.addEventListener('loadedmetadata', this.setVideoData.bind(this));
		this.ui.video.addEventListener('play', this.updatePlayState.bind(this));
		this.ui.video.addEventListener('pause', this.updatePlayState.bind(this));
		this.ui.video.addEventListener('timeupdate', this.updateCurrentTime.bind(this));
		this.ui.video.addEventListener('mouseout', this.hideUI.bind(this));
		this.ui.video.addEventListener('dblclick', this.toggleFullScreen.bind(this));
		this.ui.video.addEventListener('mousemove', this.showUI.bind(this));

		this.ui.volumeSlider.addEventListener('change', this.adjustVolume.bind(this));
		this.ui.volumeSlider.addEventListener('mousemove', this.adjustVolume.bind(this));
		this.ui.volumeSlider.addEventListener('wheel', this.adjustVolume.bind(this));

		// window selecteur trop générique, cause des soucis ailleurs si on le laisse
		// // window.addEventListener('keydown', this.onKeyDown.bind(this));
		// // window.addEventListener('keyup', this.hideUI.bind(this));
		// // window.addEventListener('resize', this.setVideoSize.bind(this));
		// // window.addEventListener('mouseup', this.onMouseUp.bind(this));
	};

	this.onKeyDown = function(e) {
		switch(e.key) {
			case 'ArrowLeft':
			case 'ArrowRight':
				this.skip(e);
			break;
			case 'ArrowUp':
			case 'ArrowDown':
				this.adjustVolume(e);
			break;
			case ' ':
				this.playVideo(e);
			break;
		}
		this.showUI();
	};

	this.showUI = function() {
		if (this.uiTimeout) clearTimeout(this.uiTimeout);
		this.ui.controls.classList.add('active');
		this.ui.video.style.cursor = 'default';
	};

	this.hideUI = function() {
		if (this.uiTimeout) clearTimeout(this.uiTimeout);
		if (this.ui.video.paused) return; 

		this.uiTimeout = setTimeout(() => {
			this.ui.controls.classList.remove('active');
			setTimeout(() => this.ui.video.style.cursor = 'none', 1000);
		}, 2000);
	};

	this.onMouseDown = function() {
		this.isMouseDown = true;
		this.showUI();
	};

	this.onMouseUp = function() {
		this.isMouseDown = false;
		if (this.videoStatus === 'paused') return;

		this.hideUI();
		this.ui.video.play();
	};

	this.updatePlayState = function() {
		this.ui.video.paused ? 
		(this.ui.playButton.classList.add('pause'), this.ui.playButton.classList.remove('start')) :
		(this.ui.playButton.classList.add('start'), this.ui.playButton.classList.remove('pause'));
	
		this.ui.video.paused ? this.showUI() : this.hideUI();
	};

	this.updatetimeBar = function(e){
		if (!this.isMouseDown && e.type === 'mousemove') return;

		this.ui.video.currentTime = this.ui.timeBar.value;
		if (!this.isMouseDown) return;

		this.ui.video.pause();
		this.showUI();
		this.hideUI();
	};

	this.updateCurrentTime = function() {
		let seconds = Math.floor(this.ui.video.currentTime % 60);
		let minutes = Math.floor(this.ui.video.currentTime / 60);
		seconds = seconds >= 10 ? seconds : '0' + seconds;
		this.ui.timeCounter.innerText = `${minutes}:${seconds} / ${this.timeTotal}`;
		if (this.isMouseDown) return;

		this.ui.timeBar.value = this.ui.video.currentTime;
		this.ui.timeProgress.style.width = ""+(this.ui.video.currentTime * 100 / this.ui.video.duration)+"%";
	};

	this.playVideo = function(e) {
		e.preventDefault();
		if (!this.ui.video.readyState >= 2) return;
		if (this.ui.video.paused) {
			this.ui.video.play();
			this.videoStatus = 'playing';
		} else {
			this.ui.video.pause(); 
			this.videoStatus = 'paused';
		}
	};

	this.adjustVolume = function(e) {
		if (e.type === 'mousemove' && !this.isMouseDown) return;
		if (e.which === 1 ) return this.ui.video.volume = this.ui.volumeSlider.value / 100;

		e.preventDefault();
		if (e.key === 'ArrowUp' || e.wheelDelta > 0) {
			this.ui.video.volume = this.ui.video.volume + .1 >= 1 ? 1 : this.ui.video.volume + .1;
			this.ui.volumeSlider.value = this.ui.video.volume * 100;
			return;
		}
		if (e.key === 'ArrowDown' || e.wheelDelta < 0) {
			this.ui.video.volume = this.ui.video.volume - .1 <= 0 ? 0 : this.ui.video.volume - .1;
			this.ui.volumeSlider.value = this.ui.video.volume * 100;
			return;
		}
		this.ui.video.volume = this.ui.volumeSlider.value / 100;  
	};

	this.toggleMute = function(e) {
		this.ui.video.muted = !this.ui.video.muted;  
		if(this.ui.video.muted){
			this.ui.video.volume = 0;
			this.ui.toggleMuteBtn.classList.add('muted')
		}else{
			this.ui.video.volume = this.ui.volumeSlider.value / 100;
			this.ui.toggleMuteBtn.classList.remove('muted')
		}
		
	};

	this.skip = function(e) {
		e.preventDefault();
		switch(e.key) {
			case 'ArrowLeft':
				this.ui.video.currentTime -= 10;
			break;
			case 'ArrowRight':
				this.ui.video.currentTime += 10;
			break;
		}
		this.ui.timeBar.value = this.ui.video.currentTime;
	};

	this.toggleFullScreen = function () {
		if(this.ui.fullscreen.classList.contains("active")){
			this.ui.fullscreen.classList.remove("active");
			if(document.exitFullscreen){
				document.exitFullscreen() ;
			} else if(document.mozExitFullscreen){
				document.mozExitFullscreen() ;
			} else if(document.webkitExitFullscreen){
				document.webkitExitFullscreen() ;
			} else if(document.webkitExitFullScreen){
				document.webkitExitFullScreen() ;
			} else if(document.msExitFullscreen){
				document.msExitFullscreen();
			} else { 
				console.error('cannot exit fullscreen mode');
			}
		}else{
			this.ui.fullscreen.classList.add("active");
			if(this.ui.player.requestFullscreen){ 
				this.ui.player.requestFullscreen();
			}else if(this.ui.player.mozRequestFullscreen){
				this.ui.player.mozRequestFullscreen();
			}else if(this.ui.player.webkitRequestFullscreen){
				this.ui.player.webkitRequestFullscreen();
			}else if(this.ui.player.webkitRequestFullscreen){
				this.ui.player.webkitRequestFullscreen();
			}else if(this.ui.player.webkitRequestFullScreen){
				this.ui.player.webkitRequestFullScreen();
			}else if(this.ui.player.msRequestFullscreen){
				this.ui.player.msRequestFullscreen();
			}else {
				console.error('fullscreen is not available');
			}
		}

		this.setVideoSize();
	};

	this.setVideoSize = function() {
		if(this.ui.video.attributes["data-src-mobile"]){
			if(window.matchMedia("(min-width: 769px)").matches){
				if(!this.ui.video.classList.contains("srcDesktop")){
					this.ui.video.classList.add("srcDesktop");
					this.ui.video.classList.remove("srcMobile");
					this.ui.video.querySelector("source").attributes['src'].value = this.ui.video.attributes["data-src-desktop"].value;
					this.ui.video.load();
				}
			}else{
				if(!this.ui.video.classList.contains("srcMobile")){
					this.ui.video.classList.remove("srcDesktop");
					this.ui.video.classList.add("srcMobile");
					this.ui.video.querySelector("source").attributes['src'].value = this.ui.video.attributes["data-src-mobile"].value;
					this.ui.video.load();
				}
			}
		}
	};

	this.setVideoData = function() {
		if (this.ui.video.readyState) {
			let seconds = Math.floor(this.ui.video.duration % 60);
			let minutes = Math.floor(this.ui.video.duration / 60);
			seconds = seconds >= 10 ? seconds : '0' + seconds;
    		this.timeTotal = `${minutes}:${seconds}`;
			this.ui.timeBar.max = this.ui.video.duration;
			this.ui.timeCounter.innerText = `0:00 / ${this.timeTotal}`;
			this.updateCurrentTime();
		} 
		this.ui.video.volume = this.ui.volumeSlider.value / 100;
		this.setVideoSize();

		if(this.ui.video.muted){
			this.ui.toggleMuteBtn.classList.add('muted')
		}else{
			this.ui.toggleMuteBtn.classList.remove('muted')
		}
	}

	this.bindUI();
	this.bindEvents();
	this.setVideoSize();
};

module.exports = videoPlayer;
